module.exports = __webpack_public_path__ + "img/lock-unlocked-01.7156d62b.svg";